import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const VUIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="VU" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M0 0v4h16V0H0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#5EAA22"
        fillRule="evenodd"
        d="M0 8v4h16V8H0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#272727"
        fillRule="evenodd"
        d="m0-1 8.335 7L0 13V-1Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={18}
        height={21}
        x={-1}
        y={-4.678}
        fill="#000"
        maskUnits="userSpaceOnUse"
      >
        <Path fill="#fff" d="M-1-4.678h18v21H-1z" />
        <Path
          fillRule="evenodd"
          d="M0-1.678 8.704 5H16v2H8.584L0 13.405V11.17L7 6 0 .767v-2.445Z"
          clipRule="evenodd"
        />
      </Mask>
      <Path
        fill="#FFD018"
        fillRule="evenodd"
        d="M0-1.678 8.704 5H16v2H8.584L0 13.405V11.17L7 6 0 .767v-2.445Z"
        clipRule="evenodd"
      />
      <Path
        fill="#272727"
        d="m8.704 5-.608.793.27.207h.338V5ZM0-1.678l.609-.793L-1-3.705v2.027h1ZM16 5h1V4h-1v1Zm0 2v1h1V7h-1ZM8.584 7V6h-.332l-.266.199.598.801ZM0 13.405h-1V15.4l1.598-1.192L0 13.405Zm0-2.235-.594-.805-.406.3v.505h1ZM7 6l.594.804 1.083-.8L7.599 5.2l-.599.8ZM0 .767h-1v.501l.401.3L0 .767ZM8.704 5l.61-.793L.608-2.471 0-1.678l-.609.794 8.705 6.677L8.704 5ZM16 5V4H8.704v2H16V5Zm0 2h1V5h-2v2h1ZM8.584 7v1H16V6H8.584v1ZM0 13.405l.598.802 8.584-6.406L8.584 7l-.598-.801-8.584 6.405.598.802Zm0-2.235h-1v2.236h2V11.17H0ZM7 6l-.594-.805-7 5.17.594.805.594.804 7-5.17L7 6ZM0 .767l-.599.8 7 5.234L7 6l.599-.801-7-5.233L0 .767Zm0-2.445h-1V.767h2v-2.445H0Z"
        mask="url(#b)"
      />
      <Path
        fill="#FFD018"
        d="M2.437 8.384v-.79c.705-.155 1.171-.358 1.399-.6.559-.69.187-2.304-.962-2.293-.569 0-1.157.27-1.157.909 0 .793.163 1.132.72 1.132.555 0 .759.03 1.124-.469l.396.123c-.391.533-.919.955-1.52.955-.991 0-1.53-.747-1.53-1.611 0-1.067.866-1.814 1.91-1.814.779 0 2.01.954 2.01 1.814 0 .86 0 1.253-.675 1.854a3.666 3.666 0 0 1-1.715.79Z"
      />
      <Path
        fill="#FFD018"
        d="M2.496 4.94c.038.01.06.05.05.087l-.056.211.138.18.07-.152a.072.072 0 0 1 .095-.037.071.071 0 0 1 .035.095l-.102.223.072.097.043-.093a.072.072 0 0 1 .13.06l-.077.165c.06.083.114.155.16.22l.073-.16a.072.072 0 0 1 .094-.035.072.072 0 0 1 .036.095l-.106.233-.006.008c.078.12.12.195.12.231 0 .04-.033.072-.072.072a.073.073 0 0 1-.072-.072.717.717 0 0 0-.093-.157l-.143.077a.071.071 0 1 1-.068-.126l.129-.07a13.623 13.623 0 0 0-.144-.2l-.204.11a.071.071 0 0 1-.067-.126l.187-.1a29.039 29.039 0 0 0-.107-.143l-.155.084a.071.071 0 1 1-.068-.126l.135-.073-.124-.164-.071.067a.072.072 0 0 1-.102-.004.072.072 0 0 1 .004-.102l.081-.076-.048-.063a.071.071 0 0 1 .114-.087l.004.005.027-.103c.01-.038.05-.06.088-.05Z"
      />
      <Path
        fill="#FFD018"
        d="M2.976 4.94a.071.071 0 0 0-.05.087l.056.211-.138.18-.07-.152a.072.072 0 0 0-.095-.037.071.071 0 0 0-.035.095l.101.223-.07.097-.044-.093a.072.072 0 0 0-.13.06l.077.165c-.06.083-.115.155-.16.22l-.073-.16a.072.072 0 0 0-.095-.035.072.072 0 0 0-.035.095l.106.233.006.008c-.079.12-.12.195-.12.231 0 .04.032.072.072.072.04 0 .072-.032.072-.072 0-.015.033-.068.093-.157l.143.077a.071.071 0 1 0 .068-.126l-.13-.07.144-.2.204.11a.072.072 0 0 0 .067-.126l-.186-.1c.034-.046.068-.094.106-.143l.156.084a.071.071 0 1 0 .067-.126l-.135-.073c.04-.053.081-.108.125-.164l.07.067a.072.072 0 0 0 .102-.004.072.072 0 0 0-.003-.102L3.16 5.24l.047-.063a.071.071 0 1 0-.112-.087l-.004.005-.027-.103a.072.072 0 0 0-.088-.05Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
